import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';

import { HomeDataResponse } from '@shared/home-sections/entities/home-data.response';
import { UserHistoryItem } from '@user-history/entities/user-history-item';
import { HttpErrorResponse } from '@angular/common/http';
import { TravelCmsHomePayload } from '@home/entities/travel-cms';

export const fetchHomeDataAction = createAction(
  type('[Home/API] Fetch home data'),
  props<{ payload: TravelCmsHomePayload }>());
export const fetchHomeRecentSearchAction = createAction(type('[Home/API] Fetch home recent search'));
export const fetchHomeDataSuccessAction = createAction(type('[Home/API] Fetch home data success'),
  props<{ response: HomeDataResponse }>());

export const fetchUserHistoryHomeAction = createAction(type('[Home/API] Fetch user history list'));
export const userHistoryHomeAction = createAction(type('[Home/DATA] Fetch user history list'),
  props<{ response: UserHistoryItem[] }>());
export const userHistoryHomeActionError = createAction(type('[Home/DATA] User History error'),
  props<{ payload: HttpErrorResponse }>());
